import React from 'react'
import styled from "styled-components";


const CardStyle = styled.div `
  .card {
    transform-style: preserve-3d;
    transition: transform 0.5s linear;
    width: 283px;
    height: 380px;
  }

  .card-box {
    width: auto;
    height: auto;
  }

  .front, .back {
    width:95%;
    height: 95%;
    backface-visibility: hidden;
    
  }

  .back{
    transform: rotateY(180deg);
    align-text:center;
  }

  .card-box:hover .card {
    transform: rotateY(180deg);
  }

  @media (max-width: 570px) {
    .card {
      width: 100%;
      width: 283px;
      height: 380px;
    } 

    .card-box {
      width: 100%;
      height: 100%;
    }
  }
`

function ImageFlipcard({flipcard}) {
  return (
    <div className="w-full ">
      <CardStyle>
      <div className="card-box  ">
        <div className='relative mx-auto card flex flex-col text-center items-center justify-center'>
          <div className="front absolute transform shadow rounded-lg bg-white flex flex-col justify-between">
            <div className="w-full">
              <img alt='flipcard' className="object-contain rounded-t-lg" src={flipcard.image}></img>
            </div>
            <h1 className="text-lpGray font-semibold h-full pt-1 lg:px-8 ">{flipcard.title}</h1>
          </div>
          <div className="back flex flex-col absolute shadow rounded-lg bg-form border-b-4 border-primary">
            <div className="back-content p-6 my-auto text-left transform ">
              <h1 className="text-lpGray font-semibold">{flipcard.title}</h1>
              <p className="text-base text-gray-800 pt-4">{flipcard.content}</p>
            </div>
          </div>
        </div>
      </div>
      </CardStyle>
    </div>
    
  )
}

export default ImageFlipcard
